/**
 * The client's EVENT COMPANY, resolved without the page that normally loads it.
 *
 * When a code chunk fails to arrive, the portal never renders, so nothing has
 * fetched the tenant's name or logo yet. A bare system error on the screen
 * where a client was about to pay reads as "the payment system is broken";
 * the same sentence under their event company's name reads as a hiccup.
 *
 * Resolution is best-effort and returns null rather than a guess. A null brand
 * means the dead-end state renders as PLAIN TEXT — never STAFFED branding.
 */
const API = process.env.REACT_APP_BACKEND_URL;

function resolveLogo(raw) {
  if (!raw) return '';
  return /^(https?:|data:)/.test(raw) ? raw : `${API}${raw}`;
}

async function portalTokenForPath() {
  const path = String(window.location.pathname || '');
  const direct = path.match(/^\/client-view\/([^/]+)/);
  if (direct) return direct[1];
  if (path.replace(/\/+$/, '') === '/payment-success') {
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    if (!sessionId) return null;
    const res = await fetch(`${API}/api/payments/stripe/status/${sessionId}`);
    if (!res.ok) return null;
    const data = await res.json();
    return data?.receipt?.portalToken || null;
  }
  return null;
}

export async function loadTenantBrand() {
  try {
    const token = await portalTokenForPath();
    if (!token) return null;
    const res = await fetch(`${API}/api/leads/client-view/${token}`);
    if (!res.ok) return null;
    const data = await res.json();
    const companyName = String(data?.companyName || '').trim();
    const companyLogo = resolveLogo(data?.companyLogo);
    if (!companyName && !companyLogo) return null;
    return { companyName, companyLogo };
  } catch {
    // A branding lookup must never be the reason a broken page stays broken.
    return null;
  }
}

export default loadTenantBrand;
